import { gql } from 'graphql-tag'

export const SUBMITTED_APP_REVIEW_DATE = gql`
  mutation submittedAppReviewDate {
    consumer: submittedAppReviewDate {
      consumerId
      submittedAppReviewDate
    }
  }
`
